// Filters whose options endpoint can return more rows than a single request
// (backend caps `limit` at 200). These options are searched and paginated on
// the server instead of being filtered client-side.
export const PAGINATED_FILTER_COLUMNS = ['local_id'];

export const FILTER_OPTIONS_PAGE_SIZE = 200;

export const isPaginatedFilterColumn = (column: string): boolean =>
  PAGINATED_FILTER_COLUMNS.includes(column);
